import AssetList from './AssetList';
import withModal from '../../utils/withModal';

const AssetListModal = withModal({
  title: 'Asset Search',
  footer: null,
  width: 1200,
})(AssetList);

export default AssetListModal;
